export const GOOGLE_MAP_API_KEY = 'AIzaSyDceclUPKtXW9Ctuu5-BWEf0HGZl8lj2bA';
